"use client"

import type React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { DendromapLoader } from "../../components/dendromap-loader"
import {
  createAdministrationItems,
  createConfigurationItems,
  createNavigationItems,
  isPathHiddenForRole,
} from "../../components/sidebar-menu"
import { useMenuConfig } from "../../hooks/api/settings/use-menu-config"
import { useMyFeatures } from "../../hooks/api/features/use-my-features"
import { useGetCurrentUser } from "../../hooks/api/users/use-current-user"
import { useLabels } from "../../hooks/use-labels"
import { AuthService } from "../../lib/api/services/auth.service"

/** Espace /superadmin : réservé aux utilisateurs `is_superadmin` (l'API vérifie aussi chaque appel). */
export function SuperAdminGuard({ children }: { children: React.ReactNode }) {
  const { data: currentUser, isLoading } = useGetCurrentUser()
  if (isLoading) return <DendromapLoader message="Vérification des droits..." />
  if ((currentUser as any)?.data?.is_superadmin !== true) return <Navigate to="/admin/dashboard" replace />
  return <>{children}</>
}

/** /admin : une page dont le menu est masqué (rôle ou fonctionnalité désactivée) renvoie au tableau de bord. */
export function MenuAccessGuard({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation()
  const { labels } = useLabels()
  const { data: menuConfig } = useMenuConfig()
  const { data: features } = useMyFeatures()
  const role = AuthService.getRole()
  const items = [
    ...createNavigationItems(labels.sidebar),
    ...createConfigurationItems(labels.sidebar),
    ...createAdministrationItems(labels.sidebar),
  ]
  if (isPathHiddenForRole(pathname, items, role, menuConfig, features)) return <Navigate to="/admin/dashboard" replace />
  return <>{children}</>
}
